import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    if (email === 'admin@hbb0011realty.com' && password === 'admin@4343') {
      localStorage.setItem('isAdminLoggedIn', 'true');
      navigate('/admin');
    } else {
      setError('Invalid email or password');
    }
  };

  return (
    <div className="min-h-screen bg-[#131313] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-[#1c1b1b] p-8 rounded-xl border border-white/10 shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#f59e0b] to-transparent"></div>
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Bebas Neue' }}>ADMIN LOGIN</h2>
          <p className="text-[#a08e7a] text-sm">Sign in to manage HBB0011 Realty</p>
        </div>
        
        {error && (
          <div className="bg-[#93000a] text-[#ffdad6] p-3 rounded mb-4 text-sm text-center">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-[#d8c3ad] mb-1">Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#0e0e0e] border border-white/10 rounded-md px-4 py-2 text-white focus:outline-none focus:border-[#f59e0b] transition-colors"
              placeholder="admin@hbb0011realty.com"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#d8c3ad] mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#0e0e0e] border border-white/10 rounded-md px-4 py-2 text-white focus:outline-none focus:border-[#f59e0b] transition-colors"
              placeholder="••••••••"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-[#f59e0b] text-[#2a1700] font-bold py-3 rounded-md hover:bg-[#ffc174] transition-colors mt-4"
          >
            LOGIN TO DASHBOARD
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
